import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Loader from "../components/Loader";
import "../App.css";
import "../css/skin-modes.css";
import "../css/custom.css";

const flagContext = require.context("../images/flags", false, /\.svg$/);
const FLAGS = {};
flagContext.keys().forEach(key => {
  const code = key.replace("./", "").replace(".svg", "");
  FLAGS[code] = flagContext(key);
});

const formatTopSellerDate = (daysAgo, time) => {
  const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  const d = new Date();
  d.setDate(d.getDate() - daysAgo);
  const day = String(d.getDate()).padStart(2, "0");
  return `${day} ${months[d.getMonth()]} ${d.getFullYear()} ${time}`;
};

const TOP_SELLER_NEWS = [
  {
    dbId: 57125,
    title: 'MIX "ALL" VALID 90%',
    date: formatTopSellerDate(0, "01:25 PM"),
    sellerName: "paul",
    sellerId: 14967,
    rating: 3.56,
    total: 2036,
    priceMin: 10,
    priceMax: 35,
    countries: ["fr","no","gb","si","mx","za","il","rs","us","co","ke","tw","ca","th","cz","ma","vn","om","nl","ro","dk","ar","br","lu","tz","pa","jp","sa","lt","tr","it","qa","in","cl","kr","at","ba","sn","gr","kw","ch","ie","pl","de","eg","my","fi","ng","es","lk","se","be","is","gh","ge","bg","mg","hr","md","au","hu","sk","pt"],
  },
  {
    dbId: 57000,
    title: 'MIX "GOAL" VALID 90%',
    date: formatTopSellerDate(1, "01:23 PM"),
    sellerName: "paul",
    sellerId: 14967,
    rating: 3.56,
    total: 1365,
    priceMin: 10,
    priceMax: 50,
    countries: ["pa","nl","mg","lk","is","br","lu","kr","sg","ng","my","qa","es","dk","pt","au","uy","ge","pr","ky","il","kw","ae","ke","om","ph","at","lv","ug","tw","cm","cn","de","bg","in","jp","mk","us","za","sk","ie","sa","vn","pl","hu","ca","mt","th","no","gb","se","it","id","ch","hk","lt","be","mx","fr","eg","nz"],
  },
  {
    dbId: 57002,
    title: 'MIX "FIRM" VALID 90%',
    date: formatTopSellerDate(2, "09:23 AM"),
    sellerName: "paul",
    sellerId: 14967,
    rating: 3.56,
    total: 1019,
    priceMin: 20,
    priceMax: 50,
    countries: ["in","ae","ec","fr","al","jp","me","sa","eg","ke","br","za","dk","ca","de","rs","sg","tz","se","hu","gr","dz","my","cn","fi","ro","by","it","hk","mn","lt","kr","si","co","il","tw","pl","om","cz","ch","py","au","gb","sn","sk","nl","md","ee","be","at","is","tr","hr","qa","ar","mx","cl","ba","us","no","ie","kw","lu","pt","es"],
  },
  {
    dbId: 57001,
    title: 'MIX "CHASE" VALID 90%',
    date: formatTopSellerDate(3, "01:22 PM"),
    sellerName: "paul",
    sellerId: 14967,
    rating: 3.56,
    total: 1327,
    priceMin: 20,
    priceMax: 50,
    countries: ["ph","ec","hu","nz","in","fr","no","lk","qa","my","sa","dk","hr","ba","bf","lu","ae","us","hk","br","gb","at","is","me","th","cz","kr","fi","tw","ch","co","pt","eg","ge","ee","gr","om","pa","tr","se","nl","ie","za","au","si","vn","kw","lt","sk","de","cl","ro","jp","sg","es","it","rs","mx","lv","be","ca","pl","ar"],
  },
  {
    dbId: 57004,
    title: 'MIX "CHASE" VALID 90%',
    date: formatTopSellerDate(3, "01:22 PM"),
    sellerName: "paul",
    sellerId: 14967,
    rating: 3.56,
    total: 1327,
    priceMin: 20,
    priceMax: 50,
    countries: ["ph","ec","hu","nz","in","fr","no","lk","qa","my","sa","dk","hr","ba","bf","lu","ae","us","hk","br","gb","at","is","me","th","cz","kr","fi","tw","ch","co","pt","eg","ge","ee","gr","om","pa","tr","se","nl","ie","za","au","si","vn","kw","lt","sk","de","cl","ro","jp","sg","es","it","rs","mx","lv","be","ca","pl","ar"],
  },
  {
    dbId: 57005,
    title: 'MIX "CHASE" VALID 90%',
    date: formatTopSellerDate(3, "01:22 PM"),
    sellerName: "paul",
    sellerId: 14967,
    rating: 3.56,
    total: 1327,
    priceMin: 20,
    priceMax: 50,
    countries: ["ph","ec","hu","nz","in","fr","no","lk","qa","my","sa","dk","hr","ba","bf","lu","ae","us","hk","br","gb","at","is","me","th","cz","kr","fi","tw","ch","co","pt","eg","ge","ee","gr","om","pa","tr","se","nl","ie","za","au","si","vn","kw","lt","sk","de","cl","ro","jp","sg","es","it","rs","mx","lv","be","ca","pl","ar"],
  },
  {
    dbId: 57006,
    title: 'MIX "CHASE" VALID 90%',
    date: formatTopSellerDate(3, "01:22 PM"),
    sellerName: "paul",
    sellerId: 14967,
    rating: 3.56,
    total: 1327,
    priceMin: 20,
    priceMax: 50,
    countries: ["ph","ec","hu","nz","in","fr","no","lk","qa","my","sa","dk","hr","ba","bf","lu","ae","us","hk","br","gb","at","is","me","th","cz","kr","fi","tw","ch","co","pt","eg","ge","ee","gr","om","pa","tr","se","nl","ie","za","au","si","vn","kw","lt","sk","de","cl","ro","jp","sg","es","it","rs","mx","lv","be","ca","pl","ar"],
  },
  {
    dbId: 57007,
    title: 'MIX "CHASE" VALID 90%',
    date: formatTopSellerDate(3, "01:22 PM"),
    sellerName: "paul",
    sellerId: 14967,
    rating: 3.56,
    total: 1327,
    priceMin: 20,
    priceMax: 50,
    countries: ["ph","ec","hu","nz","in","fr","no","lk","qa","my","sa","dk","hr","ba","bf","lu","ae","us","hk","br","gb","at","is","me","th","cz","kr","fi","tw","ch","co","pt","eg","ge","ee","gr","om","pa","tr","se","nl","ie","za","au","si","vn","kw","lt","sk","de","cl","ro","jp","sg","es","it","rs","mx","lv","be","ca","pl","ar"],
  },
  {
    dbId: 57008,
    title: 'MIX "CHASE" VALID 90%',
    date: formatTopSellerDate(3, "01:22 PM"),
    sellerName: "paul",
    sellerId: 14967,
    rating: 3.56,
    total: 1327,
    priceMin: 20,
    priceMax: 50,
    countries: ["ph","ec","hu","nz","in","fr","no","lk","qa","my","sa","dk","hr","ba","bf","lu","ae","us","hk","br","gb","at","is","me","th","cz","kr","fi","tw","ch","co","pt","eg","ge","ee","gr","om","pa","tr","se","nl","ie","za","au","si","vn","kw","lt","sk","de","cl","ro","jp","sg","es","it","rs","mx","lv","be","ca","pl","ar"],
  },
];

const NEW_NEWS = [
  {
    dbId: 57037,
    title: 'MIX "FAST" VALID 90%',
    date: formatTopSellerDate(0, "01:27 PM"),
    sellerName: "bigmoneybro",
    sellerId: 87880,
    rating: 3.02,
    total: 1276,
    priceMin: 10,
    priceMax: 23,
    countries: ["pe","cr","tt","in","bh","co","hu","pa","mx","pr","mn","it","gb","us","se"],
  },
  {
    dbId: 57040,
    title: 'MIX "UNDERWATER" VALID 80%',
    date: formatTopSellerDate(1, "01:26 PM"),
    sellerName: "weekend",
    sellerId: 220449,
    rating: 3,
    total: 725,
    priceMin: 20,
    priceMax: 40,
    countries: ["pa","us","br","de","id","mx","gb","ke","cn","ca"],
  },
];

const TOP_SELLERS = [
  { id: 14967, name: "paul", products: 650679, rating: 3.56 },
  { id: 24047, name: "codesuprime", products: 977911, rating: 3.22 },
  { id: 89229, name: "londoncity", products: 1017807, rating: 3.4 },
];

const NEWS_FEED = [
  {
    title: "We add USDT-trc20 payment method! Zero comission",
    date: "2026-02-10 13:20:15",
    content: `<div class="bbWrapper"><span style="font-size: 18px">We add USDT-trc20 payment method!</span><br>
<span style="font-size: 18px">You can use it 24/7, very stable.<br>
0% Commission.</span><br>
<span style="font-size: 18px">Instant payment in 1 minutes </span></div>`,
  },
  {
    title: "NEW DOMAINS",
    date: "2025-01-13 14:17:49",
    content: `<div align="center"><b>our actual domains</b>:<br>
stashpatrick.contact<br>
stashpatrick.cc<br>
stashpatrick.fans<br>
<br>
<b>наши актуальные домены</b>:<br>
stashpatrick.contact<br>
stashpatrick.cc<br>stashpatrick.fans<br>
<br>
<b>ALL OTHER DOMAINS ARE FAKE! // ВСЕ ОСТАЛЬНЫЕ ДОМЕНЫ ЯВЛЯЮТСЯ ФЕЙКАМИ!</b></div>`,
  },
  {
    title: "Telgram channel with updates bases",
    date: "2024-02-02 14:07:24",
    content: `[ENG]<br>We've created a Telegram news channel for updates. Now, to find out about the new database in the shop, there's no need to visit the shop directly, simply check our news channel. By subscribing to the news channel, you'll be eligible to receive 5 points through customer support (available from 1 level). <br>Happy shopping!<br><br>Link to channel: https://t.me/+jQKd4B4u3b1jZjky<b><br><br>Best regards,<br>Saint Patrick</b><br><br>[RU]<br>Дорогие клиенты. Создали в телеграмме новостной канал с апдейтами. Теперь чтобы узнать про новую базу в шопе необязательно заходить в шоп, а достаточно проверить новостной канал. За то что вы подпишетесь на новостной канал - вы сможете получить 5 поинтов через саппорта (доступно с 1 уровня). <br><br>Ссылка на канал: https://t.me/+jQKd4B4u3b1jZjky<br><br>Хороших покупок, ваш Saint Patrick.<br>`,
  },
  {
    title: "NEWS",
    date: "2023-02-25 05:38:47",
    content: `<div style="text-align: center;"><div style="text-align: left;"><b style="font-size: 16px; background-color: transparent;"><font color="#e36c09">Well, well, well, my fellow leprechauns and credit card enthusiasts.</font></b></div><font face="Times New Roman" color="#008000"><div style="text-align: left;"><b style="background-color: transparent; font-size: 0.8375rem;">Based on my experience, I decided to implement a unique cumulative <span style="font-size:18px;">discount system</span> that will allow you to receive <span style="font-size:16px;">additional bonuses for every purchase!</span></b></div></font><div style="text-align: left;"><font color="#31859b"><br></font></div><div style="text-align: left;"><font color="#31859b"><font style="background-color: transparent; font-size: 0.8375rem;">For every 1000$ deposit, </font><b style="background-color: transparent; font-size: 0.8375rem;">25 "points"</b><font style="background-color: transparent; font-size: 0.8375rem;"> will be credited to the account</font></font><font color="#008000"><font style="background-color: transparent; font-size: 0.8375rem;">.</font></font></div><div style="text-align: left;"><font style="background-color: transparent; font-size: 0.8375rem;" color="#31859b">After reaching the amount of $ 10,000, the status</font><font style="background-color: transparent; font-size: 0.8375rem;" color="#ff0000"> <span style="font-size:14px;"><font face="Arial Black">"EXCELLENT BUYER"</font></span></font><font style="background-color: transparent; font-size: 0.8375rem;" color="#31859b"> is given and there is a</font><span style="background-color: transparent; font-size: 14px;"> <b><font face="Arial Black" color="#008000">discount on all cards $1</font></b></span><br></div><div style="text-align: left;"><font color="#31859b">After reaching the amount of $ 20,000, the status of</font> <span style="font-size:14px;"><font face="Arial Black" color="#ff0000">"MAJOR BUYER"</font></span> <font color="#31859b">is given and there is a</font> <span style="font-size:14px;"><b><font face="Arial Black" color="#008000">discount on all cards of&nbsp;</font></b></span><b style="background-color: transparent; font-size: 14px;"><font face="Arial Black" color="#008000">$1.5</font></b></div><div style="text-align: left;"><span style="background-color: transparent; font-size: 0.8375rem;">For each purchase, you will be rewarded with </span><b style="background-color: transparent; font-size: 0.8375rem;">points</b><span style="background-color: transparent; font-size: 0.8375rem;"> that can be used to make additional purchases or receive </span><b style="background-color: transparent; font-size: 0.8375rem;">additional discounts.</b></div><div style="text-align: left;"><br></div><div style="text-align: left;"><i style="background-color: transparent; font-size: 0.8375rem;"><b><u><font face="Arial Black" color="#008000">Shop "points":</font></u></b></i></div><div style="text-align: left;"><br></div><div style="text-align: left;"><i style="background-color: transparent; color: rgba(255, 255, 255, 0.8); font-size: 0.8375rem;"><font color="#f79646">100 points - 50$</font></i></div><div style="text-align: left;"><i style="background-color: transparent; color: rgba(255, 255, 255, 0.8); font-size: 0.8375rem;"><font color="#f79646">200 points - 110$</font></i></div><div style="text-align: left;"><i style="background-color: transparent; color: rgba(255, 255, 255, 0.8); font-size: 0.8375rem;"><font color="#f79646">1500 points - 1250$</font></i></div><div style="text-align: left;"><i style="background-color: transparent; color: rgba(255, 255, 255, 0.8); font-size: 0.8375rem;"><font color="#f79646">120 points - 10 RANDOM CC USA.</font></i></div><div style="text-align: left;"><br></div><div style="text-align: left;"><br></div><div style="text-align: left;"><span style="background-color: transparent; font-size: 0.8375rem;">Moreover, </span><b style="background-color: transparent; font-size: 0.8375rem;">we have created a system of levels for our clients.</b></div><div style="text-align: left;"><span style="background-color: transparent; font-size: 0.8375rem;">With each new level you get not only bigger discounts, but also additional bonuses! What could be better than getting discounts that increase with every purchase?</span></div><div style="text-align: left;"><br></div><div style="text-align: left;"><b style="background-color: transparent; font-size: 0.8375rem;"><font color="#31859b">We offer 10 levels providing unique benefits.</font></b></div><div style="text-align: left;"><br></div><div style="text-align: left;"><b style="background-color: transparent; font-size: 0.8375rem;">Each level will give a discount of -<span>0.10$</span> from the cost of cards, as well as an additional <span>10$</span> at each level starting from level 2!</b></div><div style="text-align: left;"><br></div><div style="text-align: left;"><span style="background-color: transparent; font-size: 0.8375rem;"><font color="#31859b">Level 1 - after 150$ Top-up.</font></span></div><div style="text-align: left;"><span style="background-color: transparent; font-size: 0.8375rem;"><font color="#31859b">Level 2 - after 350$ Top-up.</font></span></div><div style="text-align: left;"><span style="background-color: transparent; font-size: 0.8375rem;"><font color="#31859b">Level 3 - after 700$ Top-up.</font></span></div><div style="text-align: left;"><span style="background-color: transparent; font-size: 0.8375rem;"><font color="#31859b">Level 4 - after 1200$ Top-up.</font></span></div><div style="text-align: left;"><span style="background-color: transparent; font-size: 0.8375rem;"><font color="#31859b">Level 5 - after 2000$ Top-up.</font></span></div><div style="text-align: left;"><span style="background-color: transparent; font-size: 0.8375rem;"><font color="#31859b">Level 6 - after 5000$ Top-up.</font></span></div><div style="text-align: left;"><span style="background-color: transparent; font-size: 0.8375rem;"><font color="#31859b">Level 7 - after 12000$ Top-up.</font></span></div><div style="text-align: left;"><span style="background-color: transparent; font-size: 0.8375rem;"><font color="#31859b">Level 8 - after 25000$ Top-up.</font></span></div><div style="text-align: left;"><span style="background-color: transparent; font-size: 0.8375rem;"><font color="#31859b">Level 9 - after 35000$ Top-up.</font></span></div><div style="text-align: left;"><span style="background-color: transparent; font-size: 0.8375rem;"><font color="#31859b">Level 10 - after 50000$ Top-up.</font></span></div></div>`,
  },
];

function Stars({ rating }) {
  const full = Math.floor(rating);
  return (
    <div className="text-warning mx-2">
      <span>
        {Array.from({ length: 5 }, (_, i) => (
          <i key={i} className={`fa ${i < full ? "fa-star" : "fa-star-o"} fs-12`}></i>
        ))}
      </span>
    </div>
  );
}

function SellerCard({ seller }) {
  return (
    <div className="col-md-4">
      <div className="card">
        <div className="card-body">
          <div className="text-center mt-0">
            <div className="media-body">
              <h4 className="time-title p-0 mb-0 font-weight-semibold leading-normal">
                <a href={`/seller/${seller.id}`} className="text-dark">{seller.name}</a>
              </h4>
              <span className="text-muted">Status: Silver</span>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-center">
            <div className="pe-2 d-flex align-items-center justify-content-center">
              <span className="mb-0 me-2 text-muted">Products</span>
              <span className="m-0 text-dark">{seller.products}</span>
            </div>
          </div>
        </div>
        <div className="card-footer border-top p-3">
          <div className="footer p-0 icons-bg border-0 d-flex">
            <div className="social">
              <div className="d-flex justify-content-center mx-2">
                <Stars rating={seller.rating} />
                <div className="mx-2">{seller.rating}/5</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function NewsCard({ item, gold }) {
  return (
    <div className="col-md-12">
      <div className="card">
        <div className={`card-body news-block${gold ? " gold-border" : ""}`}>
          <h4>
            <a href={`/cards/search?db[]=${item.dbId}`}>
              {item.title} [{item.date}]
            </a>
          </h4>
          <div className="d-flex">
            <a href={`/seller/${item.sellerId}`} target="_blank" rel="noopener noreferrer">
              <b>{item.sellerName}</b>
            </a>
            <Stars rating={item.rating} />
            <div>{item.rating}/5</div>
          </div>
          <p><b>Total:</b> {item.total} <b>Price: <span className="text-primary">{item.priceMin}$ - {item.priceMax}$</span></b></p>
          <p className="img-news-country">
            {item.countries.map(code => (
              <img key={code} title={code.toUpperCase()} src={FLAGS[code]} alt={code.toUpperCase()} />
            ))}
          </p>
        </div>
      </div>
    </div>
  );
}

function splitColumns(items) {
  const left = items.filter((_, i) => i % 2 === 0);
  const right = items.filter((_, i) => i % 2 === 1);
  return [left, right];
}

function formatPatrickTime(date) {
  const pad = n => String(n).padStart(2, "0");
  const hours24 = date.getUTCHours();
  const hours12 = hours24 % 12 === 0 ? 12 : hours24 % 12;
  const ampm = hours24 >= 12 ? "PM" : "AM";
  return `${pad(date.getUTCDate())}.${pad(date.getUTCMonth() + 1)}.${date.getUTCFullYear()} ${pad(hours12)}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())} ${ampm}`;
}

const TABS = [
  { key: "new", label: "New" },
  { key: "discount", label: "Discount bases" },
  { key: "no-reputation", label: "Without reputation", danger: true },
];

function News() {
  const [loading, setLoading] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("new");
  const [patrickTime, setPatrickTime] = useState(() => formatPatrickTime(new Date()));

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => setPatrickTime(formatPatrickTime(new Date())), 1000);
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return <Loader />;
  }

  const [newLeft, newRight] = splitColumns(NEW_NEWS);

  return (
    <div className="page" style={{ visibility: "visible", opacity: 1 }}>
      <div className="page-main is-expanded">
        {/* Header */}
        <Header onToggleSidebar={() => setMobileMenuOpen(o => !o)} />
        {/* Sidebar */}
        <Sidebar mobileOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} active="news" />
        {/* Main Content */}
        <div className="app-content main-content mt-0">
          <div className="side-app">
            <div className="main-container container-fluid">
              {/* Page header */}
              <div className="page-header d-flex">
                <p>Patrick Time: <span id="times">{patrickTime}</span></p>
              </div>

              {/* Top sellers */}
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-7 mb-5">
                      <h4 className="mb-3">Top seller - Updates</h4>
                      <div className="row">
                        <div className="col-md-6">
                          {splitColumns(TOP_SELLER_NEWS)[0].map(item => (
                            <NewsCard key={item.dbId} item={item} gold />
                          ))}
                        </div>
                        <div className="col-md-6">
                          {splitColumns(TOP_SELLER_NEWS)[1].map(item => (
                            <NewsCard key={item.dbId} item={item} gold />
                          ))}
                        </div>
                      </div>
                      <h4 className="mb-3">Updates</h4>

              {/* Tabs */}
              <ul className="nav nav-tabs">
                {TABS.map(tab => (
                  <li className="nav-item" key={tab.key}>
                    <a
                      className={`nav-link${activeTab === tab.key ? " active" : ""}`}
                      href={`#${tab.key}`}
                      onClick={e => { e.preventDefault(); setActiveTab(tab.key); }}
                    >
                      <h6 className={tab.danger ? "text-danger" : ""}>{tab.label}</h6>
                    </a>
                  </li>
                ))}
              </ul>

              <div className="tab-content">
                {activeTab === "new" && (
                  <div className="tab-pane fade show active">
                    <div className="pt-4">
                      <div className="row">
                        <div className="col-md-6">
                          {newLeft.map(item => (
                            <NewsCard key={item.dbId} item={item} />
                          ))}
                        </div>
                        <div className="col-md-6">
                          {newRight.map(item => (
                            <NewsCard key={item.dbId} item={item} />
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {activeTab === "discount" && (
                  <div className="tab-pane fade show active">
                    <div className="pt-4 text-center text-secondary">No discount bases at the moment.</div>
                  </div>
                )}
                {activeTab === "no-reputation" && (
                  <div className="tab-pane fade show active">
                    <div className="pt-4 text-center text-secondary">No bases without reputation at the moment.</div>
                  </div>
                )}
              </div>
                    </div>
                    <div className="col-md-5 mb-5">
                      <div className="col-md-12 mb-5">
                        <h4 className="mb-3">Top sellers</h4>
                        <div className="row">
                          {TOP_SELLERS.map(seller => (
                            <SellerCard key={seller.id} seller={seller} />
                          ))}
                        </div>
                        <div className="d-flex justify-content-center mb-3">
                          <a href="https://stashpatrick.fans/seller" className="btn btn-primary">
                            More seller
                          </a>
                        </div>
                      </div>
                      <div className="col-md-12 mb-5">
                        <h4 className="mb-3">News</h4>
                        {NEWS_FEED.map((newsItem, i) => (
                          <div className="card" key={i}>
                            <div className="card-body">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <h4>{newsItem.title}</h4>
                                <span>{newsItem.date}</span>
                              </div>
                              <div dangerouslySetInnerHTML={{ __html: newsItem.content }} />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              
            </div>
          </div>
        </div>
        {/* Footer */}
        <footer className="footer">
          <div className="container">
            <div className="row align-items-center flex-row-reverse">
              <div className="col-md-12 col-sm-12 text-center">
                Copyright Patrick Market © 2025 All rights reserved
              </div>
            </div>
          </div>
        </footer>
      </div>
      <style>{`
        .gold-border {
          border: 2px #e7c354 solid;
          border-radius: 6px;
        }
        @media (max-width: 767px) {
          .app-sidebar {
            position: fixed !important;
            left: -260px !important;
            top: 0 !important;
            height: 100vh !important;
            z-index: 1000 !important;
            transition: left 0.25s ease !important;
            overflow-y: auto !important;
          }
          .app-sidebar.mobile-open {
            left: 0 !important;
          }
          .app-sidebar .slide-menu {
            position: static !important;
            top: auto !important;
            margin-left: 0 !important;
            width: auto !important;
          }
          .app-content.main-content {
            margin-left: 0 !important;
            padding-left: 0 !important;
          }
          .page-main.is-expanded .app-content {
            margin-left: 0 !important;
          }
        }
      `}</style>
    </div>
  );
}

export default News;
